module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/873d80b60c072af2e25f0ef2a6b38682.png";